/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SCIMGroupMappingWrite = {
  idp_group_name?: string;
  role: SCIMGroupMappingWrite.role;
};
export namespace SCIMGroupMappingWrite {
  export enum role {
    '_0' = 0,
    '_2' = 2,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
  }
}

